/**
 * External Dependencies
 */
import 'jquery';
import './slick/slick.min.js';

$(document).on('ready', function() {

    cookieConsentAdjust();

    /* SKIPLINK */
    $('.skiplink').find('a').on('focusin', function() {

        $('.skiplink').addClass('skiplink--expanded');

    }).on('focusout', function() {

        $('.skiplink').removeClass('skiplink--expanded');
        
    });/* End of SKIPLINK */

    /* SIDEBAR HEIGHT */
    if($('.sidebar__wrapper') && $(window).width() >= 1024) {
        setSideBarHeight();
    }

    scrollTopBtn();

    $(window).on('resize', function() {
        if($('.sidebar__wrapper') && $(window).width() >= 1024) {
            setSideBarHeight();
        }

        scrollTopBtn();
    });

    /* SIDEBAR SCROLL */
    let sidebarScroll = $('.sidebar__wrapper');
    $('#sidebar-scroll-up').on('click', function() {
        let y = sidebarScroll.scrollTop();
        sidebarScroll.scrollTop(y - 420);
    });

    $('#sidebar-scroll-down').on('click', function() {
        let y = sidebarScroll.scrollTop();
        sidebarScroll.scrollTop(y + 420);
    });

    /* MOBILE NAVIGATION */
    $('.navigation-toggle').on('click', function() {

        if($(this).hasClass('navigation-toggle--open')) {
            $(this).removeClass('navigation-toggle--open');
            $('.mobile-navigation').removeClass('mobile-navigation--open');
            $('.mobile-navigation').attr('aria-expanded', false);
            $('body').removeClass('no-scroll');
        } else {
            $(this).addClass('navigation-toggle--open');
            $('.mobile-navigation').addClass('mobile-navigation--open');
            $('.mobile-navigation').attr('aria-expanded', true);
            $('body').addClass('no-scroll');
        }
    });

    /* SEARCH TOGGLE */
    $('.search-toggle').on('click', function() {

        if($(this).parent('.navigation-search').hasClass('navigation-search--active')) {
            $(this).parent('.navigation-search').removeClass('navigation-search--active');
            $(this).attr('aria-label', 'Open search form');
            $(this).children('span').removeClass('fa-times').addClass('fa-search');
            $(this).siblings('.search-form').attr('aria-expanded', false);
        } else {
            $(this).parent('.navigation-search').addClass('navigation-search--active');
            $(this).siblings('.search-form').attr('aria-expanded', true);
            $(this).siblings('.search-form').find('.form__input').trigger('focus');
            $(this).attr('aria-label', 'Close search form');
            $(this).children('span').removeClass('fa-search').addClass('fa-times');
        }
    });

    /* ALT FOR SUBSCRIPTION FORM */
    $('.tnp-submit-image').attr('alt', 'Penumerera');

    /* COPY MODAL*/
    $('.copy-modal-btn').on('click', function(e) {
        $('#copy-url').val($(this).data('link'));
        $('.copy-modal').addClass('copy-modal--open');
        $('.copy-modal').attr('aria-expanded', 'true');

        if(e.originalEvent.detail === 0) {
            $('.copy-modal').find('.copy-modal__copy').trigger('focus');
        }
    });

    $('.copy-modal__close').on('click', function() {
        $('.copy-modal').removeClass('copy-modal--open');
        $('.copy-modal').attr('aria-expanded', 'false');
    });

    $('.copy-modal__copy').on('click', function() {
        copyUrl();
    });

    /* SHARE POPUP */
    $('.share__button').on('click', function() {

        if($(this).siblings('.share__popup-button').hasClass('share__popup-button--open') || $(this).siblings('.share__popup').hasClass('share__popup--open')) {
            $(this).siblings('.share__popup-button').removeClass('share__popup-button--open');
            $(this).siblings('.share__popup').removeClass('share__popup--open');
        } else {
            $(this).siblings('.share__popup-button').addClass('share__popup-button--open');
        }
    });

    $('.share__popup-button').on('click', function() {
        $(this).siblings('.share__popup').toggleClass('share__popup--open');
    });

    $('body').on('click', function(e) {
        if (!$('.share').is(e.target) && $('.share').has(e.target).length === 0 && !$('.copy-modal').is(e.target) && $('.copy-modal').has(e.target).length === 0)  {
            $('.share__popup-button').removeClass('share__popup-button--open');
            $('.share__popup').removeClass('share__popup--open');
        }
    });
    
});

/* Custom cookie banner functionality */
function cookieConsentAdjust() {
    if($('.cc-blockingScreen').length && $('.cc-blockingScreen').is(':visible') && $('.cc-window').length && !$('.cc-window').is(':visible')) {
        $('.cc-window').removeClass('cc-invisible');
        $('.cc-window').addClass('cc-visible');
    }
    
    $('.cc-window .cc-compliance').prepend('<button class="cc-btn" id="avantime-settings">Anpassa urval</button>');

    $('.cc-window .cc-compliance #avantime-settings').on('click', function(){
        $('.cc-window .cc-allswitches').addClass('active');
        $(this).remove();
        $('.cc-window .cc-compliance .cc-savesettings').addClass('active');
    });
}

/* SIDEBAR HEIGHT */
function setSideBarHeight() {
    let archiveMain = $('.template-about__main');
    let mainHeight = archiveMain.outerHeight();
    
    $('.sidebar__wrapper').css('max-height', mainHeight + 'px');
}

/* COPY URL */
function copyUrl() {
    let input = $('input#copy-url');

    input.trigger('select');
    navigator.clipboard.writeText(input.val());
}

/* HIDE SCROLL TO TOP */
function scrollTopBtn() {
    let contentHeight = $('#main').outerHeight();
    let windowHeight = $(window).outerHeight();

    if(contentHeight < windowHeight) {
        $('.btn-scroll-top').addClass('btn-scroll-top--hidden');
    } else {
        $('.btn-scroll-top').removeClass('btn-scroll-top--hidden');
    }
}
